class FeaturedCollection extends HTMLElement {
  constructor() {
    super();

    this.collectionCarousel = this.querySelector(".featured-collection__collections");
    this.productCarousels = this.querySelectorAll(".featured-collection__products");
    this.collectionTitles = this.dataset.titles.split(";");
    this.shopAllButton = this.querySelector(".btn[shop-all]");
  }

  connectedCallback() {
    this.addCollectionCarouselParameters();
    this.addCarouselParameters();
  }

  addCollectionCarouselParameters() {
    Object.assign(this.collectionCarousel, {
      effect: "creative",
      speed: 400,
      creativeEffect: {
        progressMultuplier: 3,
        prev: {
          translate: [0, "2rem", 0],
          opacity: 0
        },
        next: {
          translate: [0, "2rem", 0],
          opacity: 0
        }
      },
      allowTouchMove: false,
      preventInteractionOnTransition: true,
      pagination: {
        el: ".featured-collection__pages",
        clickable: true,
        renderBullet: (index, className) => {
          return '<span class="' + className + ' switcher">' + this.collectionTitles[index] + "</span>";
        }
      },
      on: {
        slideChange: e => {
          const data = e.slides[e.activeIndex].dataset;
          const text = this.dataset.buttonLabel;
          this.shopAllButton.href = data.url;
          this.shopAllButton.querySelector("span").innerHTML = text.replace("{{ label }}", data.title);
        },
        init: swiper => {
          swiper.el.style.overflow = "visible";
        }
      }
    });

    this.collectionCarousel.initialize();
  }

  addCarouselParameters() {
    this.productCarousels.forEach((carousel, index) => {
      Object.assign(carousel, {
        pagination: {
          el: document.querySelector(`.featured-collection__products__carousel-dots--${index}`),
          clickable: true
        },
        slidesPerView: 1.2,
        spaceBetween: 12,
        slidesOffsetAfter: 16,
        slidesOffsetBefore: 16,
        roundLenghts: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        breakpoints: {
          520: {
            slidesPerView: "auto"
          },
          767: {
            slidesPerView: "auto",
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0
          },
          1440: {
            slidesPerView: "auto",
            spaceBetween: 24,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0
          }
        },
        on: {
          init: swiper => {
            swiper.el.style.overflow = "visible";
          }
        }
      });
      carousel.initialize();
    });
  }
}

if (!customElements.get("featured-collection")) customElements.define("featured-collection", FeaturedCollection);
